import ShiftEnum from "./../../../shared/ShiftEnum.js";
import vSelect from 'vue-select';
import { ValidationMessage, FormLabel } from "../../../shared/components";
import HolePopup from "./holePopup.vue";
import NotesPopup from "./notesPopup.vue";
import HoleSideView from "../../projects/components/holeSideView.vue";
import { ManipulateElement } from "@/app/shared/ManipulateElement.js";

export default {
  props: {
    entries: {
      type: Array,
      default: () => {}
    },
    stagingDailyReportId: {
      type: Number
    },
    readOnly : {
      type: Boolean,
      default: false
    },
    projectZones: {
      type: Array,
      default: () => { }
    },
    reportHoles: {
      type: Array,
      default: () => { }
    },
    projectId: {
      type: Number
    },
    addHoleToReportHoles: {
      type: Function,
      default: null
    }
  },
  components: {
    vSelect,
    ValidationMessage,
    FormLabel,
    HolePopup,
    NotesPopup,
    HoleSideView
  },
  data () {
    return {
      innerId : 0,
      activeSideView: false,
      activeHolePrompt:false,
      activeNotesPrompt:false,
      innerEntries : [],
      selectedEntry : null,
      shifts: ShiftEnum.definition,
      holePopupSelectedShift: ShiftEnum.Day,
      coreSizeList: [
        "2 HEX",
        "4_1/2IN",
        "4_3/4IN",
        "4_IN",
        "5_1/2IN",
        "5_1/4IN",
        "5_1/8IN",
        "6_1/2IN",
        "AGM",
        "AQ",
        "ATW",
        "AWT",
        "AX",
        "AXT",
        "BGM",
        "BQ",
        "BQT",
        "BQTK",
        "BT",
        "BTW",
        "BX",
        "EX",
        "EXT",
        "HQ",
        "HQ3",
        "HT",
        "HTW",
        "HW",
        "HWT",
        "JK",
        "LT",
        "NQ",
        "NQ2",
        "NQ2/BTW",
        "NQ3",
        "NTW",
        "NW",
        "NWT",
        "PQ",
        "RAB",
        "STD",
        "T-36",
        "T-46",
        "T-56",
        "T-76",
        "TK",
        "UK",
        "WL-56",
        "WL-66",
        "WL-76",
        "WL76BQTK"
      ],
      newHole: {} // Object for the sideview's v-model (not used directly)
    }
  },
  mounted() {
    this.innerEntries = this.entries;
    this.fillDrillingData();
  },
  watch: {
    entries () {
      this.innerEntries = this.entries;
      this.fillDrillingData();
    },
    projectId () {
      this.fillDrillingData();
    },
    reportHoles () {
      this.fillDrillingData();
    }
  },
  computed: {
    sortedEntries() {
      // sort using only 2 keys: shift, holeNumber because when from changes, the line might be moved to another position in the grid and it is confusing
      return this.innerEntries.sort((a, b) => {
        // shift can be null on imported entries; concatenating it would build a "null..." key
        const keyA = (a.shift ?? '') + a.holeNumber;
        const keyB = (b.shift ?? '') + b.holeNumber;
        return (keyA < keyB) ? -1 : 1
      });
    }
  },
  methods: {
    createHole()
    {
      this.innerId++;
      this.selectedEntry = {
        stagingDailyReportId : this.stagingDailyReportId,
        stagingDrillingEntryId: 0,
        holeNumber : '',
        shift : ShiftEnum.Day,
        dip : 0,
        azimut : 0,
        coreSize : 'NQ',
        from : 0,
        to : 0,
        isEndOfHole : false,
        isDevico: false,
        isDirectional: false,
        isOriented: false,
        isAutomated: false,
        notes: [],
        // the following are not mapped to the backend entity
        holeId : null,
        latestTo: 0,
        latestIsEndOfHole: false,
        innerId: this.innerId
      };
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    editHole(item)
    {
      this.selectedEntry = item;
      this.activeHolePrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    closeHolePrompt()
    {
      this.activeHolePrompt = false;
      this.selectedEntry = null;
    },
    submitHole(entry, selectedHole) {
      this.activeHolePrompt = false;
      const indexOfHole = this.reportHoles.findIndex(h => h.holeId === entry.holeId);
      if (indexOfHole === -1) this.addHoleToReportHoles(selectedHole);

      let latestTo = 0;
      let latestIsEndOfHole = false;

      // look for the later entry for the same hole
      const data = this.innerEntries.filter(e => e.holeId === entry.holeId && e.shift <= entry.shift);
      if (data.length > 0) {
        const highestData = data.sort((a, b) => { return (a.to > b.to) ? -1 : 1 });
        latestTo = highestData[0].to;
        latestIsEndOfHole = highestData[0].isEndOfHole;
      } else {
        latestIsEndOfHole = selectedHole.latestIsEndOfHole;
        latestTo = selectedHole.latestTo;
      }
      // find other entries on the same hole number that wasn't mapped to an existing hole and update them
      const entriesOnSameHoleNumber = this.innerEntries.filter(e => e.holeNumber === entry.holeNumber
        && e.innerId !== entry.innerId
        && e.holeId === 0);
      entriesOnSameHoleNumber.forEach(e => {
        e.holeNumber = selectedHole.code;
        e.holeId = selectedHole.holeId;
      });

      const existingEntry = this.innerEntries.find(e => e.innerId === entry.innerId);
      entry.holeNumber = selectedHole.code;
      if (!existingEntry) {
        entry.from = latestTo;
        entry.to = latestTo;
        entry.isEndOfHole = latestIsEndOfHole;
        entry.notes = [];
        this.innerEntries.push(entry);
      }
      else {
        const index = this.innerEntries.indexOf(existingEntry);
        Object.assign(this.innerEntries[index], entry);
      }
      this.updateHoleLatestValues();
    },
    updateHoleLatestValues() {
      this.innerEntries.forEach(element => {
        const selectedHole = this.reportHoles.find(h => h.code === element.holeNumber);
        if (selectedHole) {
          // look for the later entry for the same hole
          const data = this.innerEntries.filter(e => e.holeNumber === element.holeNumber && e.shift <= element.shift && e.from < element.from);
          if (data.length > 0) {
            const highestData = data.sort((a, b) => { return (a.to > b.to) ? -1 : 1 });
            element.latestTo = highestData[0].to;
            element.latestIsEndOfHole =  highestData[0].isEndOfHole;
          } else {
            element.latestIsEndOfHole = selectedHole.latestIsEndOfHole;
            element.latestTo = selectedHole.latestTo;
          }
        }
      });
    },
    isShiftMissing(entry) {
      // shift 0 (Day) is falsy, so a truthiness test would report it as missing
      return !entry || entry.shift === null || entry.shift === undefined;
    },
    getHoleDescription(entry) {
      if (entry) {
        // shift can be null on imported entries; getNameFor would render the raw i18n key
        return entry.holeNumber + " - " + (this.isShiftMissing(entry) ? '' : ShiftEnum.getNameFor(entry.shift));
      }
      return '';
    },
    deleteHole(hole) {
      const index = this.innerEntries.findIndex(_ => _.stagingDrillingEntryId === hole.stagingDrillingEntryId && _.holeNumber === hole.holeNumber && _.shift === hole.shift);
      this.innerEntries.splice(index, 1);
    },

    fillDrillingData() {
      this.innerEntries.forEach(entry => {
        const entryHole = this.reportHoles.find(h => h.code === entry.holeNumber);
        entry.holeId = entryHole === undefined ? 0 : entryHole.holeId;
        entry.innerId = this.innerId++;
      });

      this.updateHoleLatestValues();
    },
    editNotes(item)
    {
      this.selectedEntry = item;
      this.activeNotesPrompt = true;
      setTimeout(() => {
        this.elmnt = new ManipulateElement(".vs-dialog", document.getElementsByClassName("vs-dialog-header")[0], document.getElementsByClassName("vs-dialog-cancel")[0]);
      }, 500);
    },
    closeNotesPrompt()
    {
      this.activeNotesPrompt = false;
    },
    submitNotes(notes) {
      this.selectedEntry.notes = notes;
      this.activeNotesPrompt = false;
    },

    holeExists(holeId) {
      return this.reportHoles.find(h => h.holeId === holeId) !== undefined;
    },

    getHoleLatestFrom(holeId) {
      // if the hole is not found, return "", else return latestFrom
      return this.reportHoles.find(h => h.holeId === holeId) ? this.reportHoles.find(h => h.holeId === holeId).latestFrom : "";
    },
    getHoleLatestTo(holeId) {
      return this.reportHoles.find(h => h.holeId === holeId) ? this.reportHoles.find(h => h.holeId === holeId).latestTo : "";
    },
    isFirstHoleOccurence(indextr, data, holeId) {
      return indextr === data.map(x => x.holeId).indexOf(holeId);
    },

    openSideView(holePopupSelectedShift, updateSelectedEntry) {
      this.holePopupSelectedShift = holePopupSelectedShift;
      if (updateSelectedEntry) {
        this.newHole = {
          holeId: -1, // This is to signal the holeInserted method that it should update the selected entry
          code: this.selectedEntry.holeNumber
        }
      }
      else {
        this.newHole = {}; // Reset the sideview model
      }
      this.activeSideView = true;
    },

    closeSideView() {
      this.activeSideView = false;
    },

    // This is not used but somehow Vue 2 doesn't like it when it's removed
    // (either in the component's props or here)
    holeUpdated() {
    },

    holeInserted(hole) {
      // The -1 as the holeId is just to signal this method that it should update the selected entry
      // instead of creating a new one and appending it to the entries list
      const updateSelectedEntry = hole.holeId === -1;
      if (updateSelectedEntry) hole.holeId = 0;

      hole.projectId = this.projectId;
      this.$vs.loading();
      this.$store.dispatch("drilling/addHole", hole).then(() => {
        this.$notifySaveSuccess();
        this.closeSideView();

        if (updateSelectedEntry) {
          this.selectedEntry.holeId = hole.holeId;
          this.selectedEntry.holeNumber = hole.code;
          this.selectedEntry.shift = this.holePopupSelectedShift;
          return this.submitHole(this.selectedEntry, hole);
        }
        this.selectedEntry = {
          holeId: hole.holeId,
          holeNumber: hole.code,
          shift: this.holePopupSelectedShift
        }

      }).catch((error) => {
        this.$handleSaveError(error);
      }).finally(() => {
        this.$vs.loading.close();
      });
    }
  }
}
